import { fr as views_fr } from "./views";

const fr = {
  "app.global.spanish": "Espagnol",
  "app.global.english": "Anglais",

  "login.welcome": "Bienvenue !",
  "login.start_session": "DÉMARRER LA SESSION",
  "login.invalid_user_password": "Utilisateur ou mot de passe invalide !",
  "login.button_enter": "ENTRER",
  "login.password": "MOT DE PASSE",
  "login.database": "BASE DE DONNÉES",
  "login.username": "NOM D’UTILISATEUR",
  "login.forgot_password": "Mot de passe oublié ?",

  "board.loading_please_wait": "Chargement... Veuillez patienter !",
  "board.loading": "Chargement...",
  "board.approve": "APPROUVER",
  "board.button_edit": "MODIFIER",
  button_edit: "Modifier",
  "board.button_add": "AJOUTER",
  button_add: "Ajouter",
  "board.button_back": "RETOUR",
  "board.button_save": "ENREGISTRER",
  "board.button_remove": "SUPPRIMER",
  "board.button_replace": "REMPLACER",
  "board.filter": "FILTRE",
  "board.button_confirm": "CONFIRMER",
  "board.chart.in_thousands": "En milliers",
  "board.chart.see_report": "Voir le rapport",
  "board.sheet_select": "Feuille de calcul",
  "board.missing_required_fields": "Champs obligatoires manquants !",

  "quicktable.select_all": "TOUT",
  missing_required_fields: "Champs obligatoires manquants !",

  "board.records_found": "Enregistrements trouvés",
  "board.records_saved": "ENREGISTREMENTS SAUVEGARDÉS !",
  "board.record_created": "ENREGISTREMENT CRÉÉ !",

  "board.dialog.button_discard": "Ignorer",

  "basic_modal.button_cancel": "ANNULER",
  "basic_modal.button_ok": "OK",
  "basic_modal.button_accept": "Accepter",
  "basic_modal.button_close": "Fermer",
  "basic_modal.button_create": "Créer",

  available: "Disponible",
  not_available: "Non disponible",
  select_time: "Sélectionnez l’heure...",

  "form_cloud_image.add_photo": "Ajouter une image",

  "menu.dashboard": "TABLEAU DE BORD",
  "menu.dashboard_melhous": "MELHOUS",
  "menu.delivery": "LIVRAISONS",
  "menu.order": "COMMANDES",
  "menu.sale_order": "COMMANDE DE VENTE",
  "menu.housekeeping": "ENTRETIEN",
  "menu.rest_order": "COMMANDE RESTAURANT",
  "menu.travel_person": "VOYAGEUR",
  "menu.ticket": "GESTION DES TOURS",
  "menu.affiliates": "AFFILIÉS",
  "menu.assistant_control": "CONTRÔLE D’ACCÈS",
  "menu.sale_call_center": "ENREGISTREMENT DES COMMANDES",

  "sale.sale.number": "NUMÉRO",
  "sale.sale.sale_date": "DATE",
  "sale.sale.consumer": "CLIENT",
  "sale.sale.position": "POSITION",
  "sale.sale.channel": "CANAL",
  "sale.sale.delivery_state": "STATUT",
  "sale.sale.comment": "COMMENTAIRE",
  "sale.sale.party": "CLIENT",
  "sale.sale.waiting_time": "TEMPS D’ATTENTE",
  "sale.sale.order_status": "STATUT",
  "sale.sale.commanded": "COMMANDÉ",
  "sale.sale.draft": "BROUILLON",
  "sale.sale.billing": "FACTURATION",
  "sale.sale.invoice_number": "Numéro de facture",
  "sale.sale.pay": "PAYER",
  "sale.sale.dispatched": "EXPÉDIÉ",
  "sale.sale.rejected": "REJETÉ",
  "sale.sale.delivered": "LIVRÉ",
  "sale.sale.processing": "EN TRAITEMENT",
  "sale.sale.terminal": "TERMINAL",
  "sale.sale.gateway": "PASSERELLE",
  "sale.sale.total_amount": "TOTAL",
  "sale.sale.source": "SOURCE",
  "sale.sale.description": "DESCRIPTION",
  "sale.sale.state": "ÉTAT",
  "sale.sale.payment_method": "PAIEMENT",
  "sale.sale.cash": "ESPÈCES",
  "sale.sale.persons": "Personnes",
  "sale.sale.shipping_date": "Date d’expédition",

  "sale.line.product": "PRODUIT",
  "sale.line.quantity": "QTÉ",
  "sale.line.discount": "REMISE",
  "sale.line.unit_price": "PRIX UNITAIRE",
  "sale.line.unit": "UNITÉ",
  "sale.line.unit_price_w_tax": "PRIX UNITAIRE",
  "sale.line.sale_price_taxed": "PRIX UNIT. TTC",
  "sale.line.amount": "MONTANT",
  "sale.line.button_tag": "Étiquettes",

  "sale.sale.quote": "CONFIRMER",
  "sale.sale.salesman": "VENDEUR",
  "sale.sale.shipment_address": "ADRESSE DE LIVRAISON",
  "sale.sale.agent": "AGENT",
  "sale.sale": "VENTE",
  "sale.line": "PRODUITS",

  button_cancel: "ANNULER",
  successful_order: "COMMANDE RÉUSSIE !",
  "sale.sale.price_list": "LISTE DE PRIX",
  button_delete: "SUPPRIMER",

  "sale.sale.shipment_date": "DATE D’EXPÉDITION",
  "sale.sale.today": "AUJOURD’HUI",

  "menu.stock_request": "DEMANDE DE STOCK",
  "menu.inventory": "INVENTAIRE",
  "stock.inventory": "INVENTAIRE",
  "stock.inventory.line": "LIGNES",

  "menu.purchase_requisition": "RÉQUISITION",
  "stock.shipment.internal": "DEMANDE INTERNE",
  "stock.shipment.internal.reference ": "RÉFÉRENCE",
  "stock.shipment.internal.from_location": "DEPUIS L’EMPLACEMENT",
  "stock.shipment.internal.to_location": "VERS L’EMPLACEMENT",
  "stock.shipment.internal.requested_by": "DEMANDÉ PAR",
  "stock.shipment.internal.moves": "PRODUITS",
  "stock.shipment.internal.state": "ÉTAT",
  "stock.shipment.internal.number": "NUMÉRO",
  "stock.shipment.internal.effective_date": "DATE EFFECTIVE",
  "stock.shipment.internal.today": "AUJOURD’HUI",
  "stock.shipment.internal.wait": "CONFIRMER",
  "stock.shipment.internal.planned_start_date": "Date d’envoi planifiée",
  "stock.shipment.internal.print": "Imprimer",

  effective_date: "DATE PLANIFIÉE",
  uom: "UdM",
  default_uom: "UdM",

  "stock.move": "PRODUITS",
  "stock.move.product": "PRODUIT",
  "stock.move.uom": "UdM",
  "stock.move.quantity": "QUANTITÉ",

  waiting: "EN ATTENTE",
  request: "DEMANDE",
  billing: "FACTURATION",
  print: "IMPRIMER",

  user_has_not_access_permissions:
    "L’utilisateur n’a pas les autorisations d’accès !",

  "purchase.purchase.purchase_date": "DATE",
  "purchase.purchase.number": "NUMÉRO",
  "purchase.purchase.approved": "APPROUVÉ",
  "purchase.purchase.confirmed": "CONFIRMÉ",
  "purchase.purchase.done": "TERMINÉ",
  "purchase.purchase.processing": "EN TRAITEMENT",
  "purchase.purchase.cancelled": "ANNULÉ",
  "purchase.purchase.total_amount": "MONTANT TOTAL",
  "purchase.purchase.party": "PARTIE",
  "purchase.purchase.state": "ÉTAT",
  "purchase.purchase.project": "PROJET",
  "purchase.purchase.create_uid": "UTILISATEUR",
  "purchase.purchase.description": "DESCRIPTION",
  "purchase.purchase.payment_term": "CONDITIONS DE PAIEMENT",
  "purchase.purchase.reference": "RÉFÉRENCE",
  "purchase.purchase.untaxed_amount": "MONTANT HT",
  "purchase.purchase.tax_amount": "MONTANT TVA",
  "purchase.purchase.comment": "COMMENTAIRE",
  "purchase.purchase.today": "AUJOURD’HUI",
  "purchase.purchase": "ACHAT",
  "purchase.purchase.pending": "EN ATTENTE",
  "purchase.purchase.all": "TOUT",
  "purchase.purchase.quotation": "DEVIS",
  "purchase.purchase.draft": "BROUILLON",

  "menu.purchase": "ACHATS",
  "menu.purchase_approval": "APPROBATION D’ACHAT",
  "menu.shipment_internal": "EXPÉDITION INTERNE",

  "purchase.line": "PRODUITS",
  "product.code": "CODE",
  "product.description": "DESCRIPTION",

  "menu.surveillance_schedule": "Surveillance",
  "surveillance.schedule": "Surveillance",
  supplier: "FOURNISSEUR",
  code: "CODE",
  employee: "EMPLOYÉ",
  active: "ACTIF",
  city: "VILLE",
  name: "NOM",
  position: "POSTE",

  "board.button_reload": "RECHARGER",
  successful: "TRANSACTION RÉUSSIE !",
  total_amount_cache: "MONTANT TOTAL",
  untaxed_amount_cache: "SOUS-TOTAL",
  tax_amount_cache: "IMPÔTS",

  high: "Élevée",
  urgent: "Urgente",
  low: "Faible",

  "purchase.purchase.priority": "PRIORITÉ",
  "purchase.purchase.approval": "APPROBATION",
  "purchase.purchase.approval_user": "APPROUVÉ PAR",
  "purchase.purchase.approval_date": "DATE D’APPROBATION",
  "purchase.purchase.approval_signature": "APPROUVÉ PAR",
  "purchase.purchase.authorize": "AUTORISER",
  "purchase.purchase.authorized_user": "UTILISATEUR AUTORISÉ",
  "purchase.purchase.authorized_signature": "AUTORISÉ PAR",
  "purchase.purchase.confirm": "CONFIRMER",
  "purchase.purchase.confirmation_signature": "CONFIRMÉ PAR",
  "purchase.purchase.confirm_user": "CONFIRMÉ PAR",

  "purchase.line.product": "PRODUIT",
  "purchase.line.unit_price": "PRIX UNITAIRE",
  "purchase.line.amount": "MONTANT",
  "purchase.line.quantity": "QUANTITÉ",
  "purchase.line.description": "DESCRIPTION",

  "menu.hotel_planner": "PLANIFICATEUR",
  "menu.hotel_calendar": "CALENDRIER",
  "menu.hotel_rack": "RACK",

  "menu.take_order": "PRISE DE COMMANDE",
  "menu.order_viewer": "VISUALISEUR DE COMMANDES",

  table_assigned: "TABLE",
  command: "COMMANDER",
  note: "NOTE",
  order_sended: "Comm.",

  "sale.line.note": "Notes",
  "sale.line.requested": "Demandé",
  "sale.line.draft": "Brouillon",
  "sale.line.commanded": "Commandé",

  "room.none": "Aucun",
  "room.blocked": "Bloquée",
  "room.check_in": "Arrivée",
  "room.check_out": "Départ",
  "room.maintenance": "Maintenance",
  "room.pending": "En attente",

  "menu.self_service_sale": "VENTE EN LIBRE-SERVICE",

  "app.webcheckin": "ENREGISTREMENT WEB",
  "menu.web_checkin": "ENREGISTREMENT WEB",
  "app.webcheckin.DIRECTO": "Direct",

  "hotel.folio.guest.cedula_de_ciudadania": "Carte d’identité nationale",
  "hotel.folio.guest.pasaporte": "Passeport",
  "hotel.folio.guest.tarjeta_de_identidad": "Carte d’identité",
  "hotel.folio.guest.tarjeta_de_extranjeria": "Carte d’étranger",
  "hotel.folio.guest.cedula_de_extranjeria": "Carte d’identité étrangère",
  "hotel.folio.guest.male": "Homme",
  "hotel.folio.guest.female": "Femme",

  "booking.widget.customers.title": "Informations de réservation",
  "booking.widget.customers.name_contact": "Contact : ",
  "booking.widget.customers.name_contact.placeholder": "Nom du contact ",
  "booking.widget.customers.number": "Numéro",
  "booking.widget.customers.booking_date": "Date d’enregistrement",
  "booking.widget.customers.total_amount": "Montant total",
  "booking.widget.customers.state": "Statut",
  "booking.widget.customers.rooms": "Chambres",
  "booking.widget.customers.info_huesped": "Informations du titulaire",
  "booking.widget.customers.name": "Nom complet",
  "booking.widget.customers.phone": "Téléphone",
  "booking.widget.customers.booking_hour": "Heure",
  "booking.widget.customers.email": "E-mail",
  "booking.widget.customers.call": "Appeler",
  "booking.widget.screen.huesped_house": "Clients sur place",
  "booking.widget.screen.occupied_rooms": "Chambres occupées",
  "booking.widget.screen.last_bookings": "Dernières réservations",
  "booking.panel.more_options": "Plus d’options",
  "booking.widget.screen.view_more": "Voir plus",
  "booking.widget.screen.view_less": "Voir moins",
  "booking.widget_side.today": "Aujourd’hui",
  "booking.widget_side.tomorrow": "Demain",
  "booking.widget_side_status.revenue_today": "Revenus aujourd’hui",
  "booking.widget_side_status.revenue_tomorrow": "Revenus demain",

  "hotel.maintenance": "Maintenance",
  "hotel.maintenance.start_date": "Date de début",
  "hotel.maintenance.end_date": "Date de fin",
  "hotel.maintenance.room": "Chambre",
  "hotel.maintenance.criticality": "Criticité",
  "hotel.maintenance.issue": "Incident",
  "hotel.maintenance.confirm": "Confirmer",
  "hotel.maintenance.low": "Faible",
  "hotel.maintenance.urgent": "Urgent",
  "hotel.maintenance.important": "Important",
  "hotel.maintenance.total_days": "Nombre total de jours",

  finish: "TERMINER",

  webcheckin_success_msg:
    "Félicitations, votre enregistrement sera désormais beaucoup plus rapide dans notre hôtel et vous pourrez profiter de nos services Premium.",
  webcheckin_success_header: "Enregistrement réussi !!!",
  webcheckin_success_our_services: "Nos services",
  webcheckin_booking_page:
    "Vous pouvez désormais ajouter des clients à chacune de vos chambres réservées. Pour ajouter une personne, cliquez sur la chambre.",

  male: "Homme",
  female: "Femme",
  cedula_ciudadania: "Carte d'identité nationale",
  pasaporte: "Passeport",
  tarjeta_identidad: "Carte d'identité",
  tarjeta_extranjeria: "Carte d'identité d'étranger",
  cedula_extranjeria: "Carte de séjour",

  adult: "Adulte",
  child: "Enfant",

  type: "TYPE",
  link: "LIEN",
  file: "FICHIER",

  "menu.charts": "TABLEAU DE BORD",
  sales: "Ventes",
  payroll: "Paie",
  hotel: "Hôtel",
  crm: "CRM",
  purchases: "Achats",
  dashboard: "Tableau de bord",

  go_back: "RETOUR",
  address: "ADRESSE",
  country_residence: "PAYS DE RÉSIDENCE",
  unit: "UNITÉ",
  company: "Entreprise",
  user: "Utilisateur",
  password: "Mot de passe",
  enter: "Entrer",

  "modal_msg.record_successful": "Enregistrement effectué avec succès !",
  "modal_msg.record_warning": "Avertissement !",
  "modal_msg.record_ask": "Question",
  "modal_msg.record_error": "Erreur d’enregistrement",

  "crm.customer_service.addres": "Adresse",
  "crm.customer_service.search": "Rechercher",
  "crm.customer_service.case": "Détail de la cause",
  "crm.customer_service.response": "Réponse",
  "crm.customer_service.description": "Résumé de la demande",
  "crm.customer_service.state": "État",
  "crm.customer_service.party": "Nom",
  "crm.customer_service.cs_date": "Date",
  "crm.customer_service.number": "Numéro de dossier",
  "crm.customer_service.party_id_number": "Numéro d’identification",
  "crm.customer_service.draft": "Brouillon",
  "crm.customer_service.open": "Ouvert",
  "crm.customer_service.close": "Fermé",
  "crm.customer_service.email": "Email",
  "crm.customer_service.attach_customer_1": "Pièce jointe",
  "crm.customer_service.create_service": "CRÉER UN DOSSIER",
  "crm.customer_service.ethnical_group": "Groupe ethnique",
  "crm.customer_service.special_population": "Population spéciale",
  "crm.customer_service.personal_information": "Informations personnelles",
  "crm.customer_service.pqrs_information": "Informations PQRS",
  "crm.customer_service.demographic_information":
    "Informations sociodémographiques",
  "crm.customer_service.description_facts": "Description des faits",
  "crm.customer_service.phone": "Téléphone",
  "crm.customer_service.health_provider": "Prestataire de santé",
  "crm.customer_service.detailed_especific_1": "Détail spécifique",

  "form_modal.button_close": "FERMER",
  button_open: "OUVRIR",
  "board.dialog.button_close": "Fermer",
  "board.dialog.button_ok": "OK",
  "board.dialog.button_cancel": "Annuler",

  "planner.date": "Date",

  "hotel.folio.meal_plan": "Plan de repas",
  "hotel.folio.pending_total": "Total en attente",
  "hotel.folio.agent": "Agent",
  "hotel.folio.unit_price_w_tax": "Prix TTC",
  "hotel.folio.vehicle_plate": "Plaque du véhicule",
  "hotel.folio.guests": "Clients",
  "hotel.folio.payment_status": "Statut du paiement",

  "hotel.folio.charge": "Frais",
  "hotel.folio.charge.description": "Description",
  "hotel.folio.charges": "Frais",

  "hotel.folio.guest": "Client",
  "hotel.folio.guest.main_guest": "Client principal",
  "hotel.folio.guest.name": "Nom",
  "hotel.folio.guest.type_document": "Type de document",
  "hotel.folio.guest.id_number": "Numéro d’identification",
  "hotel.folio.guest.mobile": "Mobile",
  "hotel.folio.guest.email": "Email",
  "hotel.folio.guest.address": "Adresse",
  "hotel.folio.guest.nationality": "Nationalité",
  "hotel.folio.guest.origin_country": "Pays d’origine",
  "hotel.folio.guest.target_country": "Pays de destination",
  "hotel.folio.guest.birthday": "Date de naissance",
  "hotel.folio.guest.notes": "Notes",
  "hotel.folio.guest.visa_date": "Date du visa",
  "hotel.folio.guest.visa_number": "Numéro de visa",
  "hotel.folio.guest.sex": "Sexe",
  "hotel.folio.guest.profession": "Profession",
  "hotel.folio.guest.registro_civil": "Acte de naissance",
  "hotel.folio.guest.tarjeta_identidad": "Carte d’identité",
  "hotel.folio.guest.cedula_ciudadania": "Carte d’identité nationale",
  "hotel.folio.guest.tarjeta_extranjeria": "Carte d’étranger",
  "hotel.folio.guest.cedula_extranjeria": "Carte d’identité étrangère",
  "hotel.folio.guest.nit": "NIT",

  "hotel.folio.guest.add_guest": "Ajouter",
  "hotel.folio.guest.cancel": "Annuler",

  "hotel.folio.guest.tipo_documento_extranjero": "Type de document étranger",
  "hotel.folio.guest.pep": "PEP",
  "hotel.folio.guest.nit_otro_pais": "NIT d’un autre pays",
  "hotel.folio.guest.nuip": "NUIP",
  "hotel.folio.guest.country": "Pays",
  "hotel.folio.guest.subdivision": "Subdivision",
  "hotel.folio.guest.clone_holder": "Créer un client",

  "hotel.folio.charge.sale_date": "Date",
  "hotel.folio.charge.product": "Produit",
  "hotel.folio.charge.quantity": "Quantité",
  "hotel.folio.charge.unit_price_w_tax": "Prix unitaire TTC",
  "hotel.folio.charge.amount": "Montant",
  "hotel.folio.charge.status": "Statut",
  "hotel.folio.charge.pending": "En attente",
  "hotel.folio.charge.add_product": "Ajouter un produit",

  "app.webcheckin.customer": "CLIENT",
  "app.webcheckin.no_booking": "N° RÉSERVATION",
  "app.webcheckin.channel": "CANAL",
  "app.webcheckin.arrival_date": "DATE D’ARRIVÉE",
  "app.webcheckin.departure_date": "DATE DE DÉPART",
  "app.webcheckin.finish": "TERMINER",
  "app.webcheckin.direct": "DIRECT",
  "app.webcheckin.main_guest": "ÊTES-VOUS LE CLIENT PRINCIPAL ?",
  "app.webcheckin.name": "NOM",
  "app.webcheckin.mobile": "MOBILE",
  "app.webcheckin.email": "EMAIL",
  "app.webcheckin.address": "ADRESSE",
  "app.webcheckin.nationality": "NATIONALITÉ",
  "app.webcheckin.country_residence": "PAYS DE RÉSIDENCE",
  "app.webcheckin.sex": "SEXE",
  "app.webcheckin.type_guest": "TYPE DE CLIENT",
  "app.webcheckin.id_number": "NUMÉRO D’ID",
  "app.webcheckin.type_document": "TYPE DE DOCUMENT",
  "app.webcheckin.visa_number": "N° VISA",
  "app.webcheckin.visa_date": "DATE D’EXPIRATION DU VISA",
  "app.webcheckin.birthday": "DATE DE NAISSANCE",
  "app.webcheckin.profession": "PROFESSION",
  "app.webcheckin.add_guest": "AJOUTER UN CLIENT",
  "app.webcheckin.cancel": "ANNULER",

  "surveillance.location.code": "CODE",
  "surveillance.location.name": "NOM",
  "surveillance.location.customer": "CLIENT",
  "surveillance.location.city": "VILLE",

  "schedule.scheduling": "PLANIFICATION",

  "surveillance.schedule.shift": "Service",
  "surveillance.schedule.shift.guard": "Agent",
  "surveillance.schedule.shift.location": "Lieu",
  "surveillance.schedule.shift.shift_date": "Date",
  "surveillance.schedule.shift.replicate": "Répéter",
  "surveillance.schedule.shift.extra_shift": "Service supplémentaire",
  "surveillance.schedule.shift.shift": "Type de service",
  "surveillance.schedule.shift.duration": "Durée",
  "surveillance.schedule.shift.enter_dtime": "Entrée",
  "surveillance.schedule.shift.exit_dtime": "Sortie",
  "surveillance.schedule.shift.position": "Poste",
  "surveillance.schedule.shift.event_category": "Événement planifié",
  "surveillance.schedule.shift.event": "Événement effectif",
  "surveillance.schedule.shift.notes": "Notes",
  "surveillance.schedule.shift.event_start_date": "Début de l’événement",
  "surveillance.schedule.shift.event_end_date": "Fin de l’événement",
  "surveillance.schedule.shift.kind": "Service",
  "surveillance.schedule.shift.state": "État",
  "surveillance.schedule.shift.guard.photo_link": "Photo",
  "surveillance.schedule.shift.draft": "Brouillon",
  "surveillance.schedule.shift.performed": "Effectué",
  "surveillance.schedule.shift.schedule": "Planning",

  "surveillance.schedule.state": "État",
  "surveillance.schedule.draft": "Brouillon",
  "surveillance.schedule.planned": "Planifié",

  "schedule.shift": "SERVICE",
  "schedule.search": "Rechercher",

  "company.employee.party": "Employé",
  "company.employee.code": "Code",

  "modal.search": "RECHERCHER",

  "surveillance.schedule.period": "Période",
  "surveillance.schedule.location": "Lieu",
  "crm.opportunity.state": "État",
  "crm.opportunity.agent": "Agent",
  "crm.opportunity.party_contact": "Contact",
  "crm.opportunity.party_category": "Catégorie",
  "crm.opportunity.contact_phone": "Téléphone",
  "crm.opportunity.state.lead": "Prospect",
  "crm.opportunity.state.opportunity": "Opportunité",
  "crm.opportunity.city": "Ville",
  "crm.opportunity.conversion_probability": "Probabilité de conversion",
  "crm.opportunity.lead_origin": "Origine",
  "crm.opportunity.amount": "Montant",
  "crm.opportunity.type": "Type",
  "crm.opportunity.prospect": "Prospect",
  "crm.opportunity.end_date": "Date de fin",
  "crm.opportunity.line.payment_term": "Conditions de paiement",
  "crm.opportunity.line.description": "Description",
  "crm.opportunity.line.billing_frecuency": "Facturation",
  "crm.opportunity.line.unit": "Unité",
  "crm.opportunity.line.availability": "Disponibilité",
  "crm.opportunity.brochure": "Brochure",
  "crm.opportunity.company": "Entreprise",
  "crm.opportunity.contact_email": "Email de contact",
  "crm.opportunity.more_probabilty": "Probabilité plus élevée",
  "crm.opportunity.last_90": "Derniers 90 jours",
  "crm.opportunity.last_quotations": "Derniers devis",
  "crm.opportunity.panel.win_rate": "Taux de réussite",
  "crm.opportunity.panel.win_rate_today": "Aujourd’hui",
  "crm.opportunity.panel.win_rate_yesterday": "Hier",
  "crm.opportunity.panel.activities_today": "Activités aujourd’hui",
  "crm.opportunity.panel.activities_tomorrow": "Activités demain",
  "crm.opportunity.panel.activities_pending": "Activités en attente",
  "crm.opportunity.panel.leads": "Prospects",
  "crm.opportunity.panel.leads_draft": "Brouillon",
  "crm.opportunity.panel.leads_convert": "Convertis",
  "crm.opportunity.sales.sale_date": "Date de vente",
  "crm.prospect.name": "Nom",
  "crm.prospect.phone": "Téléphone",
  "crm.prospect.email": "Email",
  "crm.prospect.agent": "Agent",
  "modal_form.button_accept": "Accepter",
  "modal_form.button_add": "Ajouter",
  "modal_form.button_save": "Enregistrer",
  "board.button_field_create": "Créer",
  "board.button_field_edit": "Modifier",
  "party.party.id_number": "Numéro d’identification",
  "party.party.type_document": "Type de document",
  "party.party.nationality": "Nationalité",
  "party.party.main_email": "Email",
  "party.party.main_mobile": "Mobile",
  "party.party.phone": "Téléphone",
  "party.party.sex": "Sexe",
  "party.party.birthday": "Date de naissance",
  "party.party": "Ajouter un client",
  "party.party.street": "Rue",
  "party.party.account_receivable": "Compte client",
  "party.party.country": "Pays",
  "party.party.subdivision": "Subdivision",
  "party.party.city": "Ville",
  holder: "Titulaire",
  holder_guest: "Titulaire / Client",
  guest: "Client",
  no_breakfast: "Sans petit-déjeuner",
  all_inclusive: "Tout compris",
  bed_breakfast: "Petit-déjeuner inclus",
  full_american: "Américain complet",
  half_american: "Demi-américain",
  "menu.activity": "Activités",
  "sale_activity.activity.time_start": "Heure de début",
  "sale_activity.activity.time_end": "Heure de fin",
  "sale_activity.activity.available": "Disponible",
  "sale_activity.activity.quota": "Quota",
  "sale_activity.activity.state": "État",
  "sale_activity.activity.add": "Ajouter",
  "sale_activity.activity.employee": "Employé",
  "sale.sale.add_courtesy": "Ajouter une courtoisie",
  all: "Tous",
  partial: "Partiel",
  "maintenance.equipment.code": "Code",
  "maintenance.equipment.gps_link": "Lien GPS",
  "maintenance.equipment.gps_passwd": "Mot de passe GPS",
  "maintenance.equipment.brand": "Marque",
  "maintenance.equipment.type_device": "Type d’appareil",
  "maintenance.equipment.date_return": "Date de retour",
  "maintenance.equipment.issues": "Incidents",
  "maintenance.equipment.status": "Statut",
  "maintenance.equipment.available": "Disponible",
  "maintenance.equipment.maintenance": "Maintenance",
  "maintenance.equipment.not_available": "Non disponible",
  "maintenance.equipment.stolen": "Volé",
  driver_license: "Permis de conduire",
  passport: "Passeport",
  medicare_card: "Carte de sécurité sociale",
  phone: "Téléphone",
  fax: "Fax",
  email: "Email",
  chat: "Chat",
  walking: "À pied",
  web: "Web",
  channel_manager: "Gestionnaire de canaux",
  ota: "OTA",
  "rest_order.options": "Options",
  "surveillance.schedule_month.report.period": "Période",
  "surveillance.schedule_month.report.location": "Lieu",
  "surveillance.schedule_month.report": "Rapport de conformité",
  "maintenance.equipment.state": "État",
  "maintenance.equipment.excelñent": "Excellent",
  "maintenance.equipment.good": "Bon",
  "maintenance.equipment.acceptable": "Acceptable",
  "maintenance.equipment.bad": "Mauvais",
  "maintenance.equipment.product": "Produit",
  "maintenance.equipment.active": "Actif",
  "maintenance.equipment.gps_serial": "Numéro de série GPS",
  "maintenance.equipment.serial": "Numéro de série",
  "maintenance.equipment.vin": "VIN",
  "maintenance.equipment.model_num": "Numéro de modèle",
  "maintenance.equipment": "ÉQUIPEMENTS ET INSTRUMENTS",
  "menu.maintenance": "ÉQUIPEMENTS ET INSTRUMENTS",
  "menu.rentalb": "RÉSERVATION",
  monthly: "Mensuel",
  one_payment: "Paiement unique",
  bimonthly: "Paiement unique",
  biannual: "Semestriel",
  annual: "Annuel",
  "crm.customer_service": "Formulaire de réclamation",
  "sale.sale.confirmed": "Confirmé",
  "sale.sale.party.mobile": "Mobile",
  "sale.sale.party.name": "Client",
  "party.addresses": "Adresses",
  "party.addresses.street": "Rue",
  "party.addresses.country_code": "Pays",
  "party.addresses.department_code": "Département",
  "party.addresses.city_code": "Ville",
  "party.contact_mechanisms": "Moyens de contact",
  "party.contact_mechanisms.type": "Type",
  "party.contact_mechanisms.name": "Nom",
  "party.contact_mechanisms.value": "Coordonnée",
  "sale.sale.party.id_number": "N° Document",
  "date_range.select": "Sélectionner",
  "date_range.filter_date": "Date à filtrer",
  "sale.sale.reference": "Référence",
  "sale.sale.month": "Mois",
  "sale.sale.month_3": "3 mois",
  "sale.sale.month_6": "6 mois",
  "sale.sale.printBrowser": "Imprimer",
  agent: "Agent",
  news: "Actualités",
  leads: "Prospects",
  opportunity: "Opportunité",
  won: "Gagné",
  lost: "Perdu",
  cancelled: "Annulé",
  amount: "Montant",
  success_rate: "Taux de réussite",
  product: "Produit",
  accomodation: "Hébergement",
  "crm.person": "Accompagnants",
  "crm.person.name": "Nom",
  "crm.person.id_number": "N° ID",
  "crm.person.phone": "Téléphone",
  "crm.person.email": "Email",
  "sale.line.person": "Accompagnants",
  "sale.line.person.name": "Nom",
  "sale.line.person.id_number": "N° ID",
  "sale.line.person.phone": "Téléphone",
  "sale.line.person.email": "Email",
  "sale.line.person.arrival_date": "Date d’arrivée",
  "sale.line.person.today": "Aujourd’hui",
  "sale.line.person.month": "Mois",
  "sale.line.person.week": "Semaine",
  "sale.line.person.line": "Service",
  "sale.line.person.sale": "Vente",
  "web.booking.avalaible": "Disponible",
  "web.booking.occupation": "Occupation",
  "web.booking.minimum_stay": "Séjour minimum",
  "app.booking.name": "Prénom",
  "app.booking.lastname": "Nom",
  "app.booking.add_pay": "Ajouter un paiement",
  "app.booking.sex": "Genre",
  "app.booking.type_document": "Type de document",
  "app.booking.id_number": "N° Document",
  "app.booking.mobile": "Téléphone",
  "app.booking.email": "Email",
  "app.booking.address": "Adresse",
  "app.booking.btn-form": "RÉSERVER",
  "app.booking.btn-form-payment": "PAIEMENT",
  "app.booking.country": "Pays",
  "app.booking.department": "Département",
  "app.booking.city": "Ville",
  "app.booking.msg_nodata": "Aucune chambre disponible",
  "app.booking.msg_minimum_stay":
    "Un séjour minimum de {nights} nuits est requis pour les dates sélectionnées.",
  "app.booking.msg_nodate": "Sélectionnez la date d’arrivée et de départ",
  "app.booking.note": "Note",
  "menu.account_statement": "RELEVÉ DE COMPTE",
  "web.booking.txt_iva": "Frais et taxes inclus",
  "app.booking.term_cond": "Conditions générales",
  "app.booking.privacy": "Politique de confidentialité",
  "sale_pos.money_count.bill": "Billet",
  "sale_pos.money_count.quantity": "Quantité",
  "sale_pos.money_count.amount": "Montant",
  "sale_pos.money_count.total": "Total",
  "app.booking.redirect": "Redirection vers le paiement...",
  "app.booking.label_form": "Ajouter les informations du titulaire",
  "app.booking.label_aside": "Votre réservation",
  "app.booking.btn_confirm": "CONFIRMER",
  "app.booking.amount": "Total :",
  "app.booking.right_reserved": "Tous droits réservés",
  "app.booking.copyright": "Copyright Presik © 2025",
  "app.booking.validate_email": "Vérifiez votre email",
  "app.booking.create_reserve": "Réservation créée",
  "app.booking.successfully": "avec succès",
  "app.booking.alert_filter_date":
    "Sélectionnez une date de départ postérieure à la date d’arrivée.",
  "app.booking.alert_select_room":
    "Sélectionnez un type de chambre pour votre réservation.",
  "app.booking.date_payment": "Date de paiement",
  "app.booking.night": "Nuit",
  "app.booking.price": "PRIX",
  "app.booking.includes": "Comprend",
  "app.booking.btn_reserve_item": "Ajouter une réservation",
  "app.booking.btn_add_coupon": "Ajouter un coupon",
  "app.booking.note_placeholder":
    "Cher client, veuillez nous indiquer vos demandes spéciales.",
  "sale_pos.money_count": "Comptage d’argent",
  "ticket_system.ticket.status": "Statut",
  "ticket_system.ticket.waiting": "En attente",
  "ticket_system.ticket.done": "Terminé",
  "ticket_system.ticket.busy": "Occupé",
  "ticket_system.ticket.cancelled": "Annulé",
  "ticket_system.ticket.turn": "Tour n°",
  "ticket_system.ticket.number_id": "N° Document",
  "ticket_system.ticket.position.number": "Poste",
  "ticket_system.ticket.state": "État",
  "ticket_system.ticke_not_found": "Il n’y a aucun tour en attente",
  "ticket_system.ticket.add_turn": "Vous devez vous attribuer un tour",
  "ticket_system.ticket.next_turn": "PROCHAIN TOUR",
  "ticket_system.ticket.take_turn": "PRENDRE UN TOUR",
  "ticket_system.ticket.finish_turn": "TERMINER LE TOUR",
  "ticket_system.ticket.currents_turn": "Service de caisse",
  "ticket_system.ticket.attention_schedule": "Horaires d’attention",
  "ticket_system.ticket.weekday": "Lun - Ven",
  "ticket_system.ticket.wekend": "Sam - Dim",
  "hotel.calendar.add_booking": "Réservation",
  "hotel.calendar.add_maintenance": "Maintenance",
  "hotel.guest.you_can_not_clone_holder":
    "Vous ne pouvez pas créer automatiquement un client sans avoir créé au préalable le titulaire",
  "account_statement_co.advanced_report": "Rapport avancé de relevé",
  "account_statement_co.advanced": "Rapport avancé de relevé",
  "account_statement_co.advanced.description":
    "Relevé incluant tous les magasins / environnements",
  "account_statement_co.advanced.start.operation_center": "Centre d’opérations",
  "account_statement_co.advanced.start.date": "Date",
  "account_statement_co.cash_up_report": "Rapport de clôture de caisse",
  "account_statement_co.cash_up": "Rapport de clôture de caisse",
  "account_statement_co.cash_up.description":
    "Rapport individuel de clôture de caisse",
  "account_statement_co.cash_up.start.operation_center": "Date",
  "account_statement_co.cash_up.start.date": "Date",
  "account_statement_co.cash_up.start.shop": "Magasin",
  "account_statement_co.cash_up.start.user": "Utilisateur",
  "hotel.folio.guest.adult": "Adulte",
  "hotel.folio.guest.child": "Enfant",
  add_header_modal: "Ajouter",
  "hotel.folio.guest.transfer": "Transport",
  "hotel.folio.guest.notes_transfer": "Notes de transport",
  "hotel.folio.guest.cradle": "Berceau",
  "hotel.folio.guest.notes_cradle": "Notes du berceau",
  "hotel.folio.guest.pet": "Animal de compagnie",
  "hotel.folio.guest.notes_pet": "Notes sur l’animal",
};
const _fr = { ...fr, ...views_fr };
export default _fr;
